import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { SitesRouteNames, SitesRoutePathNames } from '../../../../enums';

const Component = () => import('./KDS.vue');

export default {
  path: buildChildURL(SitesRoutePathNames.KDS),
  name: SitesRouteNames.SITE_KDS,
  component: Component,
} as RouteRecordRaw;
